import { motion } from 'framer-motion'
import { useEffect, useRef } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { BookingModalHost } from '@/components/booking/booking-modal-host'
import { AppBottomNav } from './components/app-bottom-nav'
import { AppMobileTopbar } from './components/app-mobile-topbar'
import { AppSidebar } from './components/app-sidebar'
import { AppTopbar } from './components/app-topbar'
import { LocationPermissionBanner } from './components/location-permission-banner'

const VIEW_TRANSITION = { duration: 0.25, ease: 'easeOut' as const }

export function RootLayout() {
  const { pathname, key } = useLocation()
  const contentScrollRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!key) return
    contentScrollRef.current?.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [key])

  return (
    <div className="flex h-dvh w-screen overflow-hidden bg-bg-subtle">
      <AppSidebar />

      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden pb-16 md:pb-0">
        <AppMobileTopbar />
        <AppTopbar />
        <LocationPermissionBanner />

        <div
          ref={contentScrollRef}
          className="flex-1 min-h-0 overflow-x-hidden overflow-y-auto overscroll-y-contain"
        >
          <motion.main
            key={pathname}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={VIEW_TRANSITION}
            className="mx-auto flex min-h-full w-full flex-col px-5 pt-5 pb-0 md:px-8 md:pt-7 md:pb-0 xl:px-10 2xl:px-14"
          >
            <Outlet />
          </motion.main>
        </div>
      </div>

      <AppBottomNav />
      <BookingModalHost />
    </div>
  )
}
